import IconButton from "@/core/components/common/icon-button";
import UploadFile from "@/core/components/common/upload-file";
import { useDialog } from "@/core/hooks/notification";
import bookCreatorProvider from "@/core/providers/book-creator";
import { deleteUploadedFile, getAllUploadedFiles, getImagesOfOwner, UploadedFileModel } from "@/core/requests/book-creator";
import { createDirectory, deleteDirectory, DirectoryModel, DirectoryResponse, getDirectory, renameDirectory } from "@/core/requests/directory";
import { getAuthorizationToken } from "@/core/utils/http-client";
import { toastError, toastSuccess } from "@/core/utils/notification";
import { get_image_thumbnail } from "@/core/utils/utils";
import { Button } from "@headlessui/react";
import { ArrowLeftIcon, ArrowUpTrayIcon, ChevronLeftIcon, FolderArrowDownIcon, FolderPlusIcon, PencilIcon, PlusIcon, TrashIcon, ViewColumnsIcon } from "@heroicons/react/24/outline";
import { FC, useEffect, useRef, useState } from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import 'react-photo-view/dist/react-photo-view.css';
import { useLocation, useNavigate, useParams } from "react-router";


const InputBar: FC<{
    default_value: string,
    onChange: (text: string) => void
}> = ({ onChange, default_value }) => {
    const [bookName, setBookName] = useState<string>(default_value)
    return <input placeholder="新建目录名称" value={bookName} onChange={(e) => {
        setBookName(e.target.value)
        onChange(e.target.value)
    }} type="text" className="w-full bg-transparent  border-info border rounded-md p-4 text-md outline-none focus:outline-none" />
}

const MaterialLibrary = () => {
    const [list, setFiles] = useState<Nullable<DirectoryResponse>>(null)
    const dialog = useDialog();
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [directory_id, setDirectoryId] = useState<string>();
    const directory_history_list = useRef<Array<DirectoryModel>>([{
        name: 'root',
        created_at: new Date().toLocaleString(),
        updated_at: new Date().toLocaleString(),

    }]);
    const fetchData = async () => {
        const files = await getDirectory(directory_id);
        if (files) {
            setFiles(files);
        }
        console.log(files);
    }

    useEffect(() => {
        const id = params?.id;
        if (id) {
            setDirectoryId(id);
            console.log("访问", id)
        }
    }, [location])

    useEffect(() => {
        console.log("设置", directory_id)
        fetchData();
    }, [directory_id])


    const handleDeleteFile = (model: UploadedFileModel) => {
        fetchDeleteFile(model);
    }

    const fetchDeleteFile = async (model: UploadedFileModel) => {
        const res = await deleteUploadedFile(model.id);
        if (res?.success) {
            toastSuccess("删除成功");
            fetchData();
        }
    }

    const handleUploadFile = () => {
        dialog.showDialog({
            title: "上传文件",
            contentNode: <UploadFile onSuccess={() => {
                // dialog.hideDialog();
                // toastSuccess("上传成功")
                fetchData();
            }} directory_id={directory_id} />,
            cancelText: "关闭",
            confirm: false,
            // cancel:false
        })
    }
    const handleDeleteDirectory = (model: DirectoryModel) => {
        fetchDeleteDirectory(model);
    }

    const handleBackPreDirectory = (index?: number) => {
        const historyStack = directory_history_list.current;

        // 如果没有传入 index，默认返回上一级
        const targetIndex = index !== undefined ? index : historyStack.length - 2;

        // 如果目标层级小于 0，说明回到根目录
        if (targetIndex < 0) {
            setDirectoryId(undefined);
            historyStack.splice(1); // 保留根目录，仅此而已
            return;
        }

        // 截取到指定的目标层级，保留到目标层级为止
        historyStack.splice(targetIndex + 1);

        // 更新为指定层级的目录 ID
        const targetDirectoryModel = historyStack[targetIndex];
        if (targetDirectoryModel) {
            setDirectoryId(targetDirectoryModel.id);
        }
    };

    const handleGotoDeep = (model: DirectoryModel) => {
        // 更新当前目录ID
        setDirectoryId(model.id);
        // 将当前目录压入历史栈
        directory_history_list.current.push(model);
    };

    const handleCreateDirectory = () => {
        let dir_name = "新建文件夹";
        dialog.showDialog({
            title: "创建目录",
            contentNode: <InputBar default_value={dir_name} onChange={(text) => {
                dir_name = text;
            }} />,
            onConfirm: () => {
                fetchCreateDirectory(dir_name, directory_id);
            }
        })
    }

    const handleRenameDirectory = (model: DirectoryModel) => {
        if (!model?.id) {
            return toastError("无效目录");
        }
        let dir_name = model.name;
        dialog.showDialog({
            title: "修改目录名称",
            contentNode: <InputBar default_value={dir_name} onChange={(text) => {
                dir_name = text;
            }} />,
            onConfirm: () => {
                if (!model.id) return;
                fetchRenameDirectory(dir_name, model?.id);
            }
        })
    }


    const fetchRenameDirectory = async (new_name: string, id: string) => {
        const res = await renameDirectory(new_name, id);
        if (res?.success) {
            toastSuccess(res?.message ?? "修改成功");
        } else {
            toastError(res?.message ?? "修改失败");
        }
        fetchData()
    }


    const fetchDeleteDirectory = async (model: DirectoryModel) => {
        const res = await deleteDirectory(model.id);
        if (res?.success) {
            toastSuccess(res?.message ?? "修改成功");
        } else {
            toastError(res?.message ?? "修改失败");
        }
        fetchData()
    }

    const fetchCreateDirectory = async (dir_name: string, parent_id?: string) => {
        const res = await createDirectory(dir_name, parent_id);
        if (res?.success) {
            toastSuccess(res?.message ?? "创建成功");
        } else {
            toastError(res?.message ?? "创建失败");
        }
        fetchData()
    }


    const handleDisplayImages = () => {
        let selected_images = new Array<UploadedFileModel>()
        if (!directory_id) return toastError("无效目录");
        dialog.showDialog({
            title: `选择图片创作`,
            contentNode: <div className="w-[960px] h-[700px]">
                <ImagesList directory_id={directory_id} onSelect={(items) => {
                    console.log("已选择", items)
                    selected_images = items;
                }} />
            </div>,
            confirmText: "选择创作",
            onConfirm: () => {
                toastSuccess("选择成功")
                bookCreatorProvider.handleAttachTempImages(selected_images.map(_ => _.file_url));
                navigate("/creator")
            }
        })
    }



    return <div className="w-full text-start  overflow-y-scroll h-full bg-white dark:bg-dark-background">
        <div className="w-full flex items-center justify-between p-4 sticky top-0 z-50 bg-white dark:bg-dark-background">
            <div className="flex items-center">
                {
                    (directory_history_list.current.length !== 1) && <IconButton size={6} onClick={() => {
                        handleBackPreDirectory()
                    }}>
                        <ChevronLeftIcon />
                    </IconButton>
                }
                <span className="text-info text-sm ml-4">
                    {
                        directory_history_list.current.filter(_ => _.id).map((_, ndx) => {
                            return <span className="cursor-pointer hover:text-primary" onClick={() => {
                                handleBackPreDirectory(ndx + 1)
                            }} >
                                {_.name}
                                <span className="mx">/</span>
                            </span>
                        })
                    }
                </span>
                {/* <h1 className="font-bold text-md text-text dark:text-dark-text my-2 px-4 ">已上传文件</h1> */}
            </div>
            <div className="flex items-center">
                <IconButton title="新建目录" size={6} onClick={handleCreateDirectory}>
                    <FolderPlusIcon />
                </IconButton>
                <IconButton title="上传文件" size={6} onClick={handleUploadFile} className="ml-2">
                    <ArrowUpTrayIcon />
                </IconButton>
                <IconButton title="选取创作" size={6} onClick={handleDisplayImages} className="ml-2">
                    <ViewColumnsIcon />
                </IconButton>
            </div>
        </div>
        <div className="w-full p-4">
            <ul className="grid-cols-8 gap-8 grid max-xl:grid-cols-6 max-md:grid-cols-4 max-sm:grid-cols-2 min-w-96">
                {
                    list?.directories.map((_, ndx) => {
                        return <FolderItem model={_} handleDeleteDirectory={() => {
                            handleDeleteDirectory(_);
                        }} onGotoDeep={() => {
                            handleGotoDeep(_);
                        }}
                            onRename={
                                () => {
                                    handleRenameDirectory(_);
                                }
                            }
                        />
                    })
                }
                {
                    list?.files.sort((a,b) => {
                        //文件默认排序
                        const a_n = a.extra_info?.index??0;
                        const b_n = b.extra_info?.index??0;
                        return a_n - b_n;
                    }).map((_, ndx) => {
                        return <MaterialItem model={_} handleDeleteFile={() => {
                            handleDeleteFile(_);
                        }} onClick={() => {
                            // handleClick(_);
                        }} onSuccess={fetchData} />
                    })
                }
            </ul>
        </div>
    </div>
}


const FolderItem: FC<{
    model: DirectoryModel,
    handleDeleteDirectory: (model: DirectoryModel) => void,
    onGotoDeep: VoidFunction,
    onRename: VoidFunction,
}> = ({ model, handleDeleteDirectory, onGotoDeep, onRename }) => {


    return <li className="w-full relative text-center cursor-pointer list-none">
        <div className="relative pb-[100%] group border hover:border-primary border-transparent rounded-md overflow-hidden" onDoubleClick={() => {
            onGotoDeep();
        }} key={model.name}>
            <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-background dark:bg-dark-background p-4">
                <img src={`${process.env.PUBLIC_URL}/assets/images/common/folder.png`} className="w-full h-auto" alt="Folder" />
            </div>
            <div className="absolute top-2 right-2  checkbox group-hover:block hidden">
                <IconButton size={4} onClick={() => {
                    handleDeleteDirectory(model)
                }}>
                    <TrashIcon />
                </IconButton>
            </div>
        </div>
        <div className="py-4 px-2 group">
            <span className="line-clamp-1 text-md dark:text-dark-text cursor-pointer" onClick={onRename}>
                {model.name}
                {/* <span className="group-hover:block hidden absolute top-0 right-0">
                    <IconButton size={4}>
                        <PencilIcon />
                    </IconButton>
                </span> */}
            </span>
        </div>
    </li>
}


const MaterialItem: FC<{
    model: UploadedFileModel,
    onClick: VoidFunction,
    handleDeleteFile: VoidFunction,
    onSuccess: VoidFunction
}> = ({ model, onClick, handleDeleteFile, onSuccess }) => {
    const dialog = useDialog();
    const selected_images = useRef<Array<UploadedFileModel>>([]);
    const navigate = useNavigate();

    const handleConvertImage = (directory_id: string) => {
        dialog.showDialog({
            title: "解析可能耗时较长，请耐心等待",
            contentNode: <ConvertImagesPanel directory_id={directory_id} model={model} onClose={() => {
                dialog.hideDialog();
            }} onSuccess={() => {
                dialog.hideDialog();
            }} />,
            confirm: false,
            cancel: false,
        })
    }


    const handleConvertToDirectory = () => {
        let dir_name = model.original_name.split(".")[0];
        dialog.showDialog({
            title: "解析至新目录",
            contentNode: <InputBar default_value={dir_name} onChange={(text) => {
                dir_name = text;
            }} />,
            onConfirm: () => {
                fetchCreateDirectory(dir_name, model.directory);
            }
        })
    }

    const fetchCreateDirectory = async (dir_name: string, parent_id?: string) => {
        const res = await createDirectory(dir_name, parent_id);
        if (res?.success) {
            toastSuccess(res?.message ?? "解析目录创建成功");
            handleConvertImage(res?.data.id);
        } else {
            toastError(res?.message ?? "解析目录创建失败");
        }
        onSuccess()
    }

    return <li className="w-full relative text-center cursor-pointer list-none" key={model.file_name}>
        <div className="relative pb-[100%] group border hover:border-primary border-transparent rounded-md overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-background dark:bg-dark-background">
                {
                    (model.file_type === "png" || model.file_type === "jpg") && (
                        // <img src={model.file_url} className="h-full" alt={model.file_url}/>
                        <PhotoProvider>
                            <PhotoView src={model.file_url}>
                                <div className="w-full h-full absolute" style={{
                                    backgroundSize: 'contain',
                                    backgroundImage: `url(${get_image_thumbnail(model.file_url)})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center center'
                                }}>
                                </div>
                            </PhotoView>
                        </PhotoProvider>
                    )
                }
                <h1 className="text-info select-none text-2xl font-bold">{model.file_type.toUpperCase()}</h1>
            </div>
            {/* <div className="absolute top-2 left-2 w-6 h-6 checkbox group-hover:block hidden">
                <input type="checkbox" className="w-full h-full border-none" onClick={(e) => {
                    e.stopPropagation();
                }} />
            </div> */}

            <div className="absolute top-2 right-2  checkbox group-hover:block hidden">
                <div className="flex">
                    {model.file_type === "pdf" && <IconButton size={4} onClick={() => {
                        handleConvertToDirectory?.();
                    }}>
                        <FolderArrowDownIcon />
                    </IconButton>}
                    <IconButton size={4} className="ml-2" onClick={() => {
                        handleDeleteFile?.();
                    }}>
                        <TrashIcon />
                    </IconButton>
                </div>

            </div>
        </div>
        <div className="py-4 px-2">
            <strong className="line-clamp-1 text-md dark:text-dark-text">{model.original_name}</strong>
        </div>
    </li>
}


// 素材库图片列表
const ImagesList: FC<{
    directory_id: string,
    onSelect: (items: Array<UploadedFileModel>) => void
}> = ({ directory_id, onSelect }) => {
    const [list, setList] = useState<Array<UploadedFileModel>>([]);
    const [select_map, setSelectMap] = useState<Map<string, boolean>>(new Map());
    const fetchImagesOfOwner = async () => {
        const res = await getDirectory(directory_id);
        if (res) {
            const files = res.files;
            //过滤图片
            const images = files.filter(item => item.file_type === "png" || item.file_type === "jpg");
            setList([...images]);
        }
        console.log(res);
    }

    useEffect(() => {
        fetchImagesOfOwner();
    }, [])

    useEffect(() => {
        if (list?.length !== 0) {
            const new_map = new Map<string, boolean>();
            for (let i = 0; i < list.length; i++) {
                new_map.set(list[i].id, false);
            }
            setSelectMap(new_map);
        }
    }, [list])

    const handleSelect = (image_model: UploadedFileModel) => {
        setSelectMap(old_map => {
            const new_map = new Map(old_map);
            new_map.set(image_model.id, !select_map.get(image_model.id));
            return new_map;
        });
    }

    const selected_all = () => {
        return Array.from(select_map.values()).every(v => v === true);
    }

    const handleSelectAll = () => {
        setSelectMap(old_map => {
            const new_map = new Map(old_map);
            list.forEach((_, ndx) => {
                new_map.set(_.id, !selected_all());
            });
            return new_map;
        });
    }

    useEffect(() => {
        const selected_images: Array<UploadedFileModel> = [];
        select_map.forEach((v, k) => {
            if (v === true) {
                list.forEach(item => {
                    if (k === item.id) {
                        selected_images.push(item);
                    }
                })
            }
        });
        onSelect?.(selected_images);
    }, [select_map])

    return <div className=" w-full h-full    overflow-scroll">
        <div className="grid grid-cols-6 gap-2 relative">
            {
                list.sort((a,b) => {
                    //文件默认排序
                    const a_n = a.extra_info?.index??0;
                    const b_n = b.extra_info?.index??0;
                    return a_n - b_n;
                }).map((_, ndx) => {
                    return <ImageItem model={_} selected={select_map.get(_.id) ?? false} handleSelect={handleSelect} />
                })
            }
        </div>
        {
            (list.length !== 0) && <div className="w-full sticky bottom-0 left-0 border-top border-info">
                <div className="flex w-full py-4 bg-background">
                    <input id="all" checked={selected_all()} className="w-6 h-6 rounded-md border-info outline-none cursor-pointer" type="checkbox" onClick={() => {
                        handleSelectAll()
                    }} />
                    <label form="all" className="ml-2">
                        全选
                    </label>
                </div>
            </div>
        }
    </div>
}


const ImageItem: FC<{
    model: UploadedFileModel,
    selected: boolean,
    handleSelect: (model: UploadedFileModel) => void
}> = ({ model, selected, handleSelect }) => {
    return <li className="w-full relative text-center cursor-pointer list-none" key={model.file_name}>
        <div className={`relative pb-[100%] group border hover:border-primary rounded-md overflow-hidden ${selected ? "border-primary" : 'border-transparent'}`}>
            <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-background">
                <PhotoProvider>
                    <PhotoView src={model.file_url}>
                        <div className="w-full h-full absolute" style={{
                            backgroundSize: 'contain',
                            backgroundImage: `url(${get_image_thumbnail(model.file_url)})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center center'
                        }}>
                        </div>
                    </PhotoView>
                </PhotoProvider>
            </div>
            <div className={`absolute top-2 left-2 w-6 h-6 checkbox group-hover:block  ${selected ? "block" : 'hidden'}`}>
                <input type="checkbox" className="w-full h-full border-none bg-primary" onClick={(e) => {
                    e.stopPropagation();
                    handleSelect(model)
                }} checked={selected} />
            </div>
            {/* <div className="absolute top-2 right-2  checkbox group-hover:block hidden">
                <IconButton size={4} onClick={() => {
                    // handleDeleteFile?.();
                }}>
                    <TrashIcon />
                </IconButton>
            </div> */}
        </div>
        {/* <div className="py-4 px-2">
            <strong className="line-clamp-1 text-md dark:text-dark-text">{model.original_name}</strong>
        </div> */}
    </li>
}


interface ConvertSSEDataModel {
    total: number,
    index: number,
    image: any
}

const ConvertImagesPanel: FC<{
    model: UploadedFileModel,
    onClose: VoidFunction,
    onSuccess: VoidFunction,
    directory_id: string,
}> = ({ model, onClose, onSuccess, directory_id }) => {
    const [progress, setProgress] = useState(0);
    const at_present_progress = useRef(0);
    const eventSource = useRef<EventSource>();

    const fetchConvertImages = () => {
        //只创建一次
        if (eventSource.current) return;
        // convertImages(model.id)
        eventSource.current = new EventSource(`${process.env.REACT_APP_HTTP_BASE_URL}api/convert/images?id=${model.id}&directory_id=${directory_id}`, {
            withCredentials: true,
        });
        const _eventSource = eventSource.current;
        _eventSource.onmessage = function (event) {
            let data: ConvertSSEDataModel = event.data;
            if (typeof data === "string") {
                data = JSON.parse(data);
            }
            const _progress = data.index / data.total * 100;
            at_present_progress.current = _progress;
            setProgress(_progress)
            if (_progress >= 100) {
                toastSuccess("解析成功")
                onSuccess?.();
            }
            // console.log(data.index, data.total, 100, _progress, 'Progress update:', data);
            // 在这里更新进度条或执行其他操作
        };
        // eventSource.close();  // 关闭 SSE 连接
        _eventSource.onerror = function (error) {
            console.error('Error with SSE:', error);
            _eventSource.close();  // 关闭 SSE 连接
            if (at_present_progress.current < 100) {
                toastError("解析失败")
                console.error("解析失败", at_present_progress.current);
            }
            onClose();
        };
    }

    useEffect(() => {
        fetchConvertImages();
    }, [])

    return <div className="p-4 min-w-[900px]">
        <div className="h-4 w-full rounded-full bg-info">
            <div className="h-full bg-primary transition-all duration-300 rounded-full" style={{
                width: progress + '%'
            }}></div>
        </div>
        <Button onClick={
            () => {
                if (eventSource.current) {
                    console.log("成功关闭")
                    eventSource.current.close();
                    onClose();
                } else {
                    console.log("无法关闭")
                }

            }
        } className="rounded-md border border-border w-full mt-2" >{
                <p>
                    取消{(progress >> 0)}%
                </p>
            }</Button>
    </div>
}





export default MaterialLibrary;